let date = function(timestamp,sep='-'){
    let _date = new Date(timestamp);
    let y = _date.getFullYear();
    let m = _date.getMonth()+1;
    let d = _date.getDate();
    return "" + y + sep + doubleNum(m) + sep +  doubleNum(d);
}
let doubleNum = function (n) {
    if(n.length>2 || n>100){
        return n;
    }
    n = parseInt(n);
    return n>=10 ? "" + n : "0" + n;
}

let time = function (timestamp, sep=":") {
    let _date = new Date(timestamp);
    let h = _date.getHours();
    let m = _date.getMinutes();
    let s = _date.getSeconds();
    return doubleNum(h) + sep + doubleNum(m) + sep +  doubleNum(s);
}

let dateTime = function (timestamp, dateSep="-", timeSep=":") {
    return date(timestamp, dateSep) + " " + time(timestamp, timeSep);
}
/**
 * 返回1970年至今的毫秒数
 * @param secs
 * @returns {Date}
 */
let dateWithTimeIntervalSince1970 = function(secs) {
    let timestamp = secs;
    let newDate = new Date();
    newDate.setTime(timestamp);
    return newDate;
}
/**
 * 返回当月最后一天的日期对象
 * @returns {Date}
 */
let getCurrentMonthLastDay = function() {
    let date=new Date();
    let currentMonth=date.getMonth();
    let nextMonth=++currentMonth;
    let nextMonthFirstDay=new Date(date.getFullYear(),nextMonth,1);
    let oneDay=1000*60*60*24;
    return new Date(nextMonthFirstDay-oneDay);
};

/**
 *  返回当月剩余的天数
 *  @return 返回date对象
 */
let datedifference = function(sDate1,sDate2) {
    let dateSpan,
        iDays;
    sDate1 = Date.parse(sDate1);
    sDate2 = Date.parse(sDate2);
    dateSpan = sDate2 - sDate1;
    dateSpan = Math.abs(dateSpan);
    iDays = Math.floor(dateSpan / (24 * 3600 * 1000));
    return iDays
};
// 隐藏手机号中间四位
let hidePhoneNum = function(phone){
    if (String(phone).length === 11) {
        return String(phone).substr(0,3) + "****" + String(phone).substr(7);
    } else {
        return String(phone);
    }
}

var tel = function (tel, sep = " ") {
    if(tel && tel.length == 11){
        return [tel.slice(0,3),tel.slice(3,7),tel.slice(7,11)].join(sep);
    }else{
        return tel;
    }
}

let changeMBFlow = function(flow) {
    var unit = "";
    var kUnit = 1024.0;
    var kDivisor = 1000.0;
    var flowSize = flow * 1024 *1024;
    if (flowSize >= kDivisor) {
        flowSize = flowSize/kUnit;
        if (flowSize >= kDivisor) {
            flowSize = flowSize/kUnit;
            if (flowSize >= kDivisor) {
                flowSize = flowSize/kUnit;
                if (flowSize >= kDivisor) {
                    unit = "TB";
                    flowSize = flowSize/kUnit;
                }else {
                    unit = "GB";
                }

            }else {
                unit = "MB";
            }
        }else {
            flowSize = flowSize/kUnit;
            unit = "MB";
        }
    }else {
        flowSize = flowSize/(kUnit*kUnit);
        unit = "MB";
    }

    var flowInt = parseInt(flowSize*1000);
    return flowInt/1000.0 + ''+ unit;
}
let keepTwodecimalFull = function (num) {//保留两位小数
    var result = parseFloat(num);
    if(isNaN(result)){
        return "";
    }
    result = Math.round(num * 100) / 100;
    var s_x = result.toString();
    var pos_decimal = s_x.indexOf('.');//小数点的所索引值

    //当整数时，pos_decimal = -1 自动补0
    if(pos_decimal < 0){
        pos_decimal = s_x.length;
        s_x += '.';
    }
    while (s_x.length <= pos_decimal + 2){
        s_x += '0';
    }
    return s_x;
}
let toYuan = function(money) {  //分->显示元
    if(money === "") return "";
    var a = parseInt(money)/100;
    var str = a + '';
    var arr = str.split('.');
    arr[1] = ((arr[1] || '') + '00');
    for(var i = 0; i<arr.length; i++){
        arr[i] = arr[i].replace(/[^0-9\-]/);
    }
    arr[1] = arr[1].substr(0, 2);
    return [arr[0], arr[1]].join('.');
}
module.exports = {
    date,
    time,
    dateTime,
    doubleNum,
    changeMBFlow,
    dateWithTimeIntervalSince1970,
    getCurrentMonthLastDay,
    datedifference,
    hidePhoneNum,
    tel,
    keepTwodecimalFull,
    toYuan
}



// WEBPACK FOOTER //
// ./src/filters/filters.js